module.exports = __webpack_public_path__ + "static/media/report-yo-digital.38705b8f.jpg";